module.exports = "/_next/static/images/projectsEnergy1-b716bc79922d7251fe28b7b87a465628.webp";